import React from 'react'
import { Icon } from '@chakra-ui/react'

export default function ControlButton({ onClick, icon, customClass }) {
  return (
    <div className={`gcd-gl-control ol-control ${customClass}`}>
      <button type="button" className='gcd-gl-btn' onClick={onClick}>
        <Icon as={icon} w={4} h={4} color="white" />
      </button>
    </div>
  )
}
